/* eslint-disable react/no-array-index-key */
import React from 'react';
import * as S from './styles';

type Props = {
  className?: string;
  list: string[] | React.ReactElement[] | null;
};

const isStringArray = (test: any[]): test is string[] => {
  return Array.isArray(test) && test.every(value => typeof value === 'string');
};

export const InfoList = ({ className, list }: Props) => {
  if (!list?.length) return null;

  return (
    <S.List className={className}>
      {list &&
        isStringArray(list) &&
        (list as string[]).map((item, index) => {
          return (
            item && (
              <S.Item key={index}>
                <S.Content>{item}</S.Content>
              </S.Item>
            )
          );
        })}

      {list &&
        !isStringArray(list) &&
        (list as React.ReactElement[]).map((item, index) => {
          return item && <S.Item key={index}>{item}</S.Item>;
        })}
    </S.List>
  );
};

export default InfoList;
